"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : MODAL : STYLES --------------- ++++++++++ */


var _default = {
  modal: {
    background: (0, _index.convertHexToRGB)(_index.theme.color.light.light.swatch, 90),
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: '0',
    left: '0',
    zIndex: '-1',
    opacity: '0',
    overflow: 'auto',
    // make sure modal is scrollable for shorter
    // interior
    '& .modalinterior': {
      display: 'table',
      // convert to table so we can center view cell so user can still always scroll contents of modal
      width: '100%',
      height: '100%',
      '& .modalcontent': {
        display: 'table-cell',
        // convert to cell and center everything
        verticalAlign: 'middle',
        textAlign: 'center',
        width: '100%',
        height: '100%',
        '& .modalpage': {
          display: 'inline-block',
          // inline this element so it will center properly (and apply modal design styles below)
          background: '#fff',
          padding: (0, _index.pxToEm)(16),
          border: "".concat((0, _index.pxToEm)(1), " solid #EDEDED"),
          boxShadow: "0 ".concat((0, _index.pxToEm)(1), " ").concat((0, _index.pxToEm)(1), " 0 #EDF1FA"),
          position: 'relative',
          textAlign: 'left',
          // close button
          '& .close': {
            background: _index.theme.color.light.light.swatch,
            border: (0, _index.replacePXinStringWithEM)("1px solid #E6E9F1"),
            borderTop: '0',
            borderRight: '0',
            cursor: 'pointer',
            padding: (0, _index.replacePXinStringWithEM)("10px 15px"),
            position: 'absolute',
            top: '0',
            right: '0',
            zIndex: '4',
            transition: 'filter .2s linear 0s',
            '& .icon': {
              color: (0, _index.convertHexToRGB)(_index.theme.color.supporting.dark.swatch, 50),
              fontSize: '125%'
            },
            '&:hover': {
              '& .icon': {
                filter: 'brightness(65%)'
              }
            }
          },
          // page / subpage
          '& .subpage': {
            width: '90vw' // extend to full width of viewport (each page/subpage will have a max width they will expand too) ... this will allow the modal to flex with the browser size and stop at specific sizes we desire

          }
        }
      }
    },
    // modal active
    '&.active': {
      animationName: 'fadeIn',
      animationDuration: '.3s',
      animationDelay: '0s',
      animationFillMode: 'forwards',
      zIndex: '900',
      // needs to be this to be on top of tooltips
      '& .close': {
        animationName: 'rotateIn',
        animationDuration: '.6s',
        animationDelay: '0s',
        animationFillMode: 'forwards'
      }
    }
  }
};
exports.default = _default;